import React from 'react';
import NavBar from '../components/Navbar/NavBar';
const DemoProduct = () => {
    // Since there is no longer a need for form state management, all related states and functions are removed.

    const redirectToGoogleForm = () => {
        window.location.href = 'https://forms.gle/yN5rKfAiyeQQMQEw8';
    };
    return (       <>
            <NavBar />
            <div className="flex justify-center items-center mt-8 bg-white py-12 lg:py-24">
                <div className="container mx-auto my-8 px-4 lg:px-20">
                    <div className="flex flex-col lg:flex-row w-full space-y-8 lg:space-y-0 lg:space-x-8">
                        <div className="bg-white p-8 my-4 md:px-12 rounded-2xl shadow-2xl w-full lg:w-3/5">
                            <h1 className="font-bold text-center text-[rgb(0,153,153)] uppercase text-4xl">Let's Connect</h1>
                            <p className="mt-4 text-center">At YANIVA VENTURES PRIVATE LIMITED, we provide comprehensive SME IPO consultancy and corporate advisory services. Our expertise guides businesses through capital structuring, due diligence, and successful public listings on SME exchanges.</p>
                            <button type="button" id="submitBtn" className="uppercase text-sm font-bold tracking-wide bg-[rgb(0,153,153)] hover:bg-[rgb(0,133,133)] text-white p-3 rounded-lg w-full focus:outline-none" onClick={redirectToGoogleForm}>
                                Send Message
                            </button>
                        </div>           
                        <div className="w-full lg:w-2/5 px-8 py-6 bg-[rgb(0,153,153)] rounded-2xl text-white">
                            <h2 className="text-3xl mb-4">Office Address</h2>
                            <p>D-910, Swati Clover, Near Shilaj Circle, Sadar Patel Ring Road, Ahmedabad - 380 059 Gujarat, India</p>
                            <h2 className="text-3xl mt-5 mb-4">Call Us</h2>
                            <p>Phone Number: +91 91069 30955</p>
                            <h2 className="text-3xl mt-5">Send an E-mail</h2>
                            <p>info@yanivaventures.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DemoProduct;
